var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-exam-arrange mb8" }, [
    _c(
      "div",
      [
        _c(
          "yxt-steps",
          { attrs: { active: _vm.step, basic: "" } },
          [
            _c("yxt-step", {
              attrs: { title: _vm.$t("pc_biz_ote_lbl_baseinfo") },
            }),
            _c("yxt-step", {
              attrs: { title: _vm.$t("pc_biz_ote_lbl_examsetting") },
            }),
            _vm.needCheck
              ? _c("yxt-step", {
                  attrs: { title: _vm.$t("pc_biz_ote_lbl_marksetting") },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "pt40" },
      [
        _c("base-info", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === 0,
              expression: "step === 0",
            },
          ],
          ref: "base",
          attrs: {
            functionCode: _vm.functionCode,
            dataPermissionCodes: _vm.dataPermissionCodes,
            reward: _vm.reward,
            id: _vm.id,
            arrange: _vm.arrange,
            masterId: _vm.masterId,
            masterName: _vm.masterName || "",
            masterType: _vm.masterType,
          },
          on: {
            next: _vm.next,
            "update:id": function ($event) {
              _vm.id = $event
            },
            needCheckChange: _vm.needCheckChange,
          },
        }),
        _c("setting", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === 1,
              expression: "step === 1",
            },
          ],
          ref: "setting",
          attrs: {
            functionCode: _vm.functionCode,
            dataPermissionCodes: _vm.dataPermissionCodes,
            id: _vm.id,
            arrange: _vm.arrange,
          },
          on: { next: _vm.next },
        }),
        _c("mark-setting", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step === 2,
              expression: "step === 2",
            },
          ],
          ref: "mark",
          attrs: {
            functionCode: _vm.functionCode,
            dataPermissionCodes: _vm.dataPermissionCodes,
            id: _vm.id,
            arrange: _vm.arrange,
          },
          on: { next: _vm.next },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "fixedFooterStyle width960" }, [
      _c(
        "div",
        { staticClass: "text-right pr32" },
        [
          _vm.step > 0
            ? _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm(-1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_prev")))]
              )
            : _vm._e(),
          _vm.maxStep === _vm.step
            ? _c(
                "yxt-button",
                {
                  attrs: { type: _vm.maxStep > _vm.step ? "" : "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm(0)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirm")))]
              )
            : _vm._e(),
          _vm.maxStep > _vm.step
            ? _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_next")))]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }